var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLusd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs49"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    id: "rect2",
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(11.766666,11.766666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g129",
    transform: "matrix(3.7795277,0,0,3.7795277,-11.766667,-11.766667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)",
    transform: "matrix(0.06615426,0,0,0.06634542,2.4106565e-7,-0.02554746)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-0.007)",
    id: "g15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 101.714,81.709 A 63.907,63.907 0 0 1 51.675,126.8 V 108.588 A 30.378,30.378 0 0 0 63.039,100.96 29.384,29.384 0 0 0 67.5,94.7 29.685,29.685 0 0 0 70.96,80.637 C 70.96,64.537 59.337,58.1 48.44,53.326 l -5.518,-2.439 c -5.9,-2.646 -10.413,-5 -10.413,-9.029 0,-5.569 4.86,-8.562 9.444,-8.562 4.878,0 7.645,1.8 10.568,6.867 l 2.266,3.926 14.581,-9.357 -1.9,-3.528 A 28.319,28.319 0 0 0 51.676,17.604 V 0.9 c 1.418,0.242 2.819,0.553 4.238,0.917 0.138,0.035 0.294,0.069 0.45,0.1 a 3.682,3.682 0 0 1 0.467,0.121 0.535,0.535 0 0 1 0.138,0.035 c 0.381,0.1 0.778,0.19 1.176,0.311 a 63.992,63.992 0 0 1 43.569,79.325 z",
    transform: "translate(23.721,0.614)",
    fill: "#745ddf",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.779,81.972 c 0,7.334 -6.625,11.865 -12.748,11.865 -7.351,0 -11.554,-6.071 -12.367,-11.71 L 50.972,77.232 33.33,82.2 l 0.8,3.944 c 2.525,12.436 11.018,21.379 22.555,24.077 v 17.625 a 64.405,64.405 0 0 1 -9.271,-1.782 c -0.432,-0.1 -0.848,-0.225 -1.28,-0.346 A 64.037,64.037 0 0 1 0,64.295 V 2.805 A 2.528,2.528 0 0 1 2.525,0.28 h 54.156 v 17.608 a 25.936,25.936 0 0 0 -15.1,11.692 24.69,24.69 0 0 0 -3.252,12.4 v 0.346 C 38.5,56.684 49.053,62.686 59.016,67.2 l 4.984,2.162 0.415,0.19 c 7.902,3.616 12.364,5.985 12.364,12.42 z",
    transform: "translate(0,0.162)",
    fill: "#2eb6ea",
    id: "path9"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.33,0.392)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 80.621,81.251 a 29.685,29.685 0 0 1 -3.459,14.062 29.384,29.384 0 0 1 -4.463,6.261 30.378,30.378 0 0 1 -11.364,7.626 l 0.008,18.3 -5.115,0.452 c 0,0 -10.969,0.329 -13.581,0 L 42.62,110.379 C 31.084,107.68 22.591,98.738 20.066,86.3 l -0.8,-3.944 17.642,-4.964 0.692,4.895 C 38.417,87.928 42.62,94 49.971,94 c 6.123,0 12.748,-4.532 12.748,-11.865 0,-6.434 -4.463,-8.8 -12.367,-12.419 l -0.415,-0.19 -4.981,-2.162 C 34.993,62.848 24.442,56.846 24.269,42.49 V 42.144 A 24.69,24.69 0 0 1 27.521,29.744 25.936,25.936 0 0 1 42.62,18.05 V 0.424 C 54.156,0.326 55.039,0.394 61.335,1.5 v 16.723 a 28.319,28.319 0 0 1 15.792,13.6 l 1.9,3.528 -14.578,9.349 -2.266,-3.926 c -2.923,-5.068 -5.691,-6.867 -10.568,-6.867 -4.584,0 -9.444,2.992 -9.444,8.562 0,4.03 4.514,6.382 10.413,9.029 L 58.1,53.94 C 69,58.714 80.621,65.148 80.621,81.251 Z",
    transform: "translate(-19.27,-0.392)",
    fill: "#ffffff",
    id: "path11"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLusd);
export default __webpack_public_path__ + "static/media/LUSD.9587a9f2.svg";
export { ForwardRef as ReactComponent };